import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import {
  selectProgressCareUser,
  selectProgressLocationsByVisit,
  selectProgressVisitType,
} from '../../../redux/appointmentForm/selectors';
import * as inspectReq from '../../../redux/appointmentForm/requests/inspection-req';

const mapStateToProps = state => ({
  locations: selectProgressLocationsByVisit(state),
  visitType: selectProgressVisitType(state),
  careUser: selectProgressCareUser(state),
});
const mapDispatchToProps = {
  setLocation: appointmentProgressActions.setLocation,
  inspectAll: inspectReq.actions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentLocations/enhance.js